"use client";
import { Fragment, useEffect, useState } from "react";
import StepContainer from "../../../components/new_components/StepContainer";
import { userBankStore } from "../../../store/creditStore/userBankStore";
import { useCreditStore } from "../../../store/creditStore/creditUserStore";
import { stepsCreditStore } from "../../../store/creditStore/stepsCreditStore";
import { WarningAlert } from "../../../components/alerts/warningAlert";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { InfoAlert } from "../../../components/alerts/infoAlert";
import BankFlowSelector from "./bankFlowSelector/BankFlowSelector";
import BankFlow from "./bankFlowSelector/bankFlow";
import CardFlow from "./bankFlowSelector/cardFlow";
import FilterableSelect from "../../../components/new_components/FilterableSelect";
import {
  bankAccountOptions,
  homologateBankNameAccount,
  typeBankAccountOptions,
} from "../../../utils/options_selects";
import CardSelect from "../../../components/new_components/CardSelcted";
import StepInput from "../../../components/new_components/StepInput";
import { CreditsService } from "../../../services/credits/credits.service";
import {
  resolveInitialStep,
} from "./bankFlowSelector/utils/routeStepResolver";
import { useLocation } from "react-router-dom";
import { useBankTokenization } from "./bankFlowSelector/utils/useBankTokenization";
import { useMobileDetection } from "../../../hooks/use-mobile-detection";

// const getInitialStep = (bank, tokenIdWompi) => {
//   if (!bank) return 1;
//   if (hasToken(tokenIdWompi)) return 4; // tiene token → confirmar
//   if (WOMPI_BANK_VALUES.includes(bank)) return 2; // banco Wompi sin token → flujo banco
//   return 3; // otro banco sin token → flujo tarjeta
// };

const DatosFlowConnectBank = ({
  onStepChange,
  stepTitlesGeneral,
  currentStepGeneral,
  isDesktop,
  currentStep: parentStep,
}) => {
  const { bankUserStore, saveUserBank, loadUserBank } = userBankStore();
  const { creditUserStore, loadUser } = useCreditStore();
  const { stepCredit, saveSteps, loadSteps } = stepsCreditStore();
  const [errors, setErrors] = useState({});
  const [tokenIdWompi, setTokenIdWompi] = useState("");
  const { screenHeight } = useMobileDetection();

  const [formDataBank, setFormDataBank] = useState({
    accountNumber: "",
    bankAccount: "",
    typeBankAccount: "",
    paymentBankSelected: "",
  });

  const [currentStep, setCurrentStep] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const [selectedBank, setSelectedBank] = useState(null);
  const [isError, setIsError] = useState(false);
  const [newBankAccount, setNewBankAccount] = useState([]);
  const [currentText, setCurrentText] = useState("Continuar");
  const [currentStepResume, setCurrentStepResume] = useState(false);

  const [, setIsDisabled] = useState(false);
  const { pathname } = useLocation();
  const { tokenizedBanks, loadingBanks } = useBankTokenization();


  const getFormHeight = () => {
    if (screenHeight <= 490) return "200px";
    if (screenHeight <= 550) return "260px";
    if (screenHeight <= 599) return "300px";
    if (screenHeight <= 650) return "370px";
    if (screenHeight <= 800) return "470px";
    if (screenHeight <= 1000) return "660px";
    if (screenHeight > 1001) return "830px";
    return "820px";
  };

  const stepTitles = [
    isDesktop ? "Selecciona tu banco" : "Selecciona tu banco.",
    isDesktop ? "Conecta tu banco" : "Conecta tu banco.",
    isDesktop ? "Conecta tu tarjeta" : "Conecta tu tarjeta.",
    isDesktop
      ? "Donde quieres recibir tu desembolso"
      : "Donde quieres recibir tu desembolso.",
    isDesktop
      ? "Donde quieres recibir tu desembolso"
      : "Donde quieres recibir tu desembolso.",
    isDesktop
      ? "Revisa que los datos estén correctos."
      : "Revisa que los datos estén correctos.",
  ];
  const totalSteps = stepTitles.length;
  const WOMPI_BANK_VALUES = [];

  const stepSubTitles = [
    isDesktop &&
    "Elige la cuenta o tarjeta donde recibes tu nómina y realizas tus movimientos. Esto nos permitirá configurar tus pagos de forma segura.",
    isDesktop && "Sigue los pasos para conectar tu banco de forma segura.",
    isDesktop && "Conecta tu tarjeta débito o crédito.",
    isDesktop &&
    "Verifica cuidadosamente la información. Si tu cuenta bancaria está mal escrita tu desembolso puede tomar más tiempo",
    isDesktop &&
    "Verifica cuidadosamente la información. Si tu cuenta bancaria está mal escrita tu desembolso puede tomar más tiempo",
  ];

  const resetButtonState = () => {
    setIsDisabled(false);
    setIsError(false);
  };

  /* =========================
     HELPERS
  ========================== */

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "warning") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenWarning(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenWarning(!isOpen);
      }, 6000);
    }

    if (type === "error") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenError(isOpen);

      setTimeout(() => {
        setMessageAlert("");
        setAlertSession(!isOpen);
        setIsOpenError(!isOpen);
      }, 8000);
    }
  };

  const handleOpenAlertInfo = (type, message, isOpen) => {
    if (type === "info") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenInfo(isOpen);
    }

    setTimeout(() => {
      setMessageAlert("");
      setAlertSession(!isOpen);
      setIsOpenInfo(!isOpen);
    }, 6000);
  };

  const handleBankSelected = (bank) => {
    const updated = { ...formDataBank, paymentBankSelected: bank.value };
    setFormDataBank(updated);
    saveUserBank(updated);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // ← Sin el guard if(value.length > 0) que bloqueaba el seteo
    const newValue =
      name === "accountNumber" ? String(value).replace(/\D/g, "") : value;

    setFormDataBank((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    resetButtonState();
  };

  const editOptions = (numberStep) => {
    setCurrentText("Volver al resumen");
    setCurrentStep(numberStep);
    setCurrentStepResume(true);
    resetButtonState(); // ✅ FIX
  };

  const handleNext = (fromFlow, flowData = null) => {
    if (!validateStep(currentStep)) return;

    if (currentStep < totalSteps) {
      if (currentStepResume) {
        setCurrentStep(totalSteps);
        setCurrentStepResume(false);
        resetButtonState(); // ✅ FIX
        return;
      }

      let bankSeSelected = selectedBank
        ? selectedBank
        : creditUserStore?.bankAccount;
      const autoSubmitBanks = WOMPI_BANK_VALUES.filter((v) => v !== 21);
      if (fromFlow && autoSubmitBanks.includes(bankSeSelected)) {
        const autoData = {
          bankAccount: bankSeSelected,
          accountNumber: flowData?.phoneNumber || "",
          typeBankAccount: "ahorros",
          paymentBankSelected: bankSeSelected,
        };
        setFormDataBank(autoData);
        handleSubmit(autoData);
        return;
      }

      setTimeout(() => {
        setCurrentStep((prev) => {
          // Viene de completar un flujo (BankFlow o CardFlow) → siempre al paso 4
          if (fromFlow) return 4;

          // Viene del selector de banco → decide qué flujo abrir
          if (
            selectedBank &&
            (tokenIdWompi === null || tokenIdWompi === undefined)
          ) {
            return WOMPI_BANK_VALUES.includes(selectedBank) ? 2 : 3;
          }

          if (
            currentStep === 4 &&
            (creditUserStore?.bankAccount === 30 ||
              creditUserStore?.bankAccount === 31)
          ) {
            return currentStep + 2;
          }

          // Cualquier otro paso → avanza normal
          return currentStep + 1;
        });
        resetButtonState(); // ✅ FIX
      }, 100);
      saveSteps({
        stepInternal: fromFlow
          ? 4
          : selectedBank
            ? WOMPI_BANK_VALUES.includes(selectedBank)
              ? 2
              : 3
            : currentStep + 1,
        stepGeneral: parentStep,
        loading: true,
      });
      saveUserBank(formDataBank);
      resetButtonState();
      return;
    }
    handleSubmit();
  };

  const handleSubmit = async (data = null) => {
    setIsLoading(true);
    setIsDisabled(true);

    try {
      await handleBankUpdate(data);
    } catch (error) {
      resetButtonState();
    } finally {
      setIsLoading(false);
    }
  };

  const handleBankUpdate = async (data = null) => {
    try {
      const userDoc = localStorage.getItem("doc");
      const payload = data || formDataBank;
      if (!userDoc) {
        handleOpenAlert(
          "error",
          "No se encontró la información del usuario. Por favor, inicia sesión nuevamente.",
          true,
        );
        return;
      }

      const { error, message } = await CreditsService.updateBankCredit(
        payload,
        userDoc,
      );
      const dataMessage = message;
      if (error) {
        handleOpenAlert(
          "error",
          `${dataMessage.message}. Intenta nuevamente.`,
          true,
        );
        console.error("Error al actualizar banco:", dataMessage.message);
        return;
      }

      // Mensaje de éxito
      handleOpenAlertInfo(
        "info",
        "¡Datos bancarios actualizados correctamente!",
        true,
      );
      onStepChange(parentStep + 1);
    } catch (error) {
      console.error("Error inesperado al actualizar banco:", error);
      handleOpenAlert(
        "error",
        "Ocurrió un error inesperado. Por favor, intenta más tarde.",
        true,
      );
    }
  };

  const handlePrevGeneral = () => {
    resetButtonState(); // ✅ FIX
    setTimeout(() => {
      onStepChange(parentStep - 1);
    }, 150);
  };

  const handlePrev = () => {
    resetButtonState();

    if (
      currentStep === 1 ||
      currentStep === 2 ||
      currentStep === 3 ||
      (currentStep === 4 && tokenIdWompi !== null && tokenIdWompi !== undefined)
    ) {
      handlePrevGeneral();
      return;
    }

    setTimeout(() => {
      // Desde paso 5 o 6 → simplemente retrocede uno
      if (currentStep > 4) {
        if (
          currentStep === 5 &&
          (creditUserStore?.bankAccount === 30 ||
            creditUserStore?.bankAccount === 31)
        ) {
          return setCurrentStep((prev) => prev - 2);
        }
        setCurrentStep((prev) => prev - 1);
        return;
      }

      // Desde paso 4 → vuelve al flujo correspondiente (2 o 3)
      // if (currentStep === 4) {
      //   let bankSeSelected = selectedBank
      //     ? selectedBank
      //     : creditUserStore?.bankAccount;
      //   const backPass = WOMPI_BANK_VALUES.includes(bankSeSelected) ? 2 : 3;
      //   setCurrentStep(backPass);
      // }
    }, 150);
  };

  const validateStep = (step) => {
    const newErrors = {};
    switch (step) {
      case 1:
        if (!formDataBank.paymentBankSelected) {
          newErrors.paymentBankSelected = "Campo obligatorio";
          setIsDisabled(true);
        }

        break;
      case 4:
        if (!formDataBank.bankAccount) {
          newErrors.bankAccount = "Campo obligatorio";
          setIsDisabled(true);
        }
        if (!formDataBank.accountNumber) {
          newErrors.accountNumber = "Campo obligatorio";
          setIsDisabled(true);
        } else {
          if (!/^\d+$/.test(formDataBank.accountNumber)) {
            newErrors.accountNumber = "Solo se permiten números";
            setIsDisabled(true);
          } else if (formDataBank.accountNumber.length < 6) {
            newErrors.accountNumber = "Mínimo 6 dígitos";
            setIsDisabled(true);
          } else if (formDataBank.accountNumber.length > 20) {
            newErrors.accountNumber = "Máximo 20 dígitos";
            setIsDisabled(true);
          }
        }
        break;
      case 5:
        if (!formDataBank.typeBankAccount) {
          newErrors.typeBankAccount = "El tipo de cuenta es obligatorio";
          setIsDisabled(true);
        }
        break;

      default:
        break;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* =========================
     RENDER
  ========================== */
  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <BankFlowSelector
            isDesktop={isDesktop}
            initialBank={formDataBank.bankAccount}
            onComplete={handleBankSelected}
            prevGeneral={handlePrevGeneral}
            onBankChange={(val) => {
              setSelectedBank(val);
              setFormDataBank((prev) => ({
                ...prev,
                bankAccount: val,
                paymentBankSelected: val,
              }));
            }}
          />
        );

      case 2:
        return (
          <BankFlow
            bankValue={formDataBank.bankAccount}
            isDesktop={isDesktop}
            onComplete={(flowData) => {
              handleNext(true, flowData);
            }}
            prevGeneral={handlePrevGeneral}
            onBack={handlePrev}
            setProductAccount={(value) => {
              setFormDataBank((prev) => ({
                ...prev,
                accountNumber: value,
              }));
            }}
          />
        );

      case 3:
        return (
          <CardFlow
            isDesktop={isDesktop}
            bankValue={formDataBank.bankAccount}
            onComplete={() => {
              handleNext(true);
            }}
            prevGeneral={handlePrevGeneral}
            onBack={handlePrev}
          />
        );

      case 4:
        return (
          <div
            className="space-y-6 text-center flex flex-col px-4 sm:px-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
              gap: isDesktop
                ? "clamp(20px, 3vh, 40px)"
                : "clamp(16px, 2vh, 24px)",
              padding: isDesktop ? "clamp(20px, 3vh, 40px)" : "16px",
            }}
          >
            {!isDesktop && (
              <p
                className="text-muted-foreground font-bold2"
                style={{
                  fontSize: "clamp(18px, 2.2vw, 24px)",
                  textAlign: "center",
                  maxWidth: "400px",
                  margin: "0 auto",
                  lineHeight: "1.3",
                }}
              >
                ¿Cual es tu número de cuenta?
              </p>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "clamp(16px, 2.5vh, 32px)",
                minHeight: 0,
                maxWidth: isDesktop ? "600px" : "100%",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <div>
                <FilterableSelect
                  options={newBankAccount.map((banck) => ({
                    label: banck.label,
                    value: banck.value,
                    icon: banck.icon,
                  }))}
                  label={"Banco"}
                  value={formDataBank.bankAccount}
                  onChange={handleInputChange}
                  name="bankAccount"
                  placeholder="Selecciona tu banco"
                  error={errors.bankAccount}
                  required
                  isDesktop={isDesktop}
                />
              </div>

              <div
                style={{
                  marginRight: isDesktop && "clamp(50px, 4vh, 50px)",
                  marginLeft: isDesktop && "clamp(50px, 4vh, 50px)",
                }}
              >
                <StepInput
                  name="accountNumber"
                  value={formDataBank.accountNumber}
                  label={"Número de cuenta"}
                  onChange={handleInputChange}
                  error={errors.accountNumber}
                  required
                  placeholder="49000000564"
                  autoFocus={true}
                  type="number"
                  isDesktop={isDesktop}
                />
              </div>
            </div>
          </div>
        );

      case 5:
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              height:
                isDesktop &&
                typeBankAccountOptions.length === 2 &&
                "-webkit-fill-available",
            }}
          >
            {!isDesktop && (
              <div
                className="text-center"
                style={{
                  width: "260px",
                }}
              >
                <p className="text-muted-foreground font-bold2 text-2xl">
                  ¿Que tipo de cuenta tienes?
                </p>
              </div>
            )}

            <CardSelect
              data={typeBankAccountOptions}
              value={formDataBank.typeBankAccount}
              name="typeBankAccount"
              error={errors.typeBankAccount}
              onChange={handleInputChange}
              multiple={false}
              isDesktop={isDesktop}
            />
          </div>
        );

      case 6:
        return (
          <div
            className="space-y-6"
            style={{
              height: isDesktop && "-webkit-fill-available",
              display: isDesktop && "flex",
              justifyContent: isDesktop && "center",
            }}
          >
            {!isDesktop && (
              <div className="text-center flex flex-col items-center">
                <h2
                  className="font-bold2 text-foreground mb-2"
                  style={{ fontSize: "20px" }}
                >
                  Woohoo!!, casi listos 🚀✨
                </h2>
              </div>
            )}
            <div
              className="space-y-3"
              style={{
                width: "-webkit-fill-available",
                display: isDesktop && "flex",
                justifyContent: isDesktop && "center",
                alignItems: isDesktop && "center",
              }}
            >
              <div
                className="grid grid-cols-1 gap-4 text-sm "
                style={{
                  backgroundColor: isDesktop ? "#565584" : "#2C2447",
                  padding: "22px 16px",
                  marginBottom: "20px",
                  borderRadius: "8px",
                  width: isDesktop && "60%",
                }}
              >
                <div className="flex flex-row justify-between group items-center">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Banco
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      {homologateBankNameAccount(
                        formDataBank.bankAccount,
                        "icon",
                      ) && (
                          <span className="flex items-center">
                            {homologateBankNameAccount(
                              formDataBank.bankAccount,
                              "icon",
                            )}
                          </span>
                        )}
                      {
                        newBankAccount.find(
                          (dept) => dept.value === formDataBank.bankAccount,
                        )?.label
                      }
                    </p>
                  </div>
                </div>

                <div className="flex flex-row justify-between group items-center">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Número
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "14px" }}
                    >
                      {formDataBank.accountNumber}
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(4);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-between group items-center">
                  <span
                    className="font-medium text-muted-foreground text-lg"
                    style={{ color: isDesktop ? "#E1DFE5" : "#BEBCC2" }}
                  >
                    Tipo de cuenta
                  </span>
                  <div className="flex flex-row gap-7 items-center">
                    <p
                      className="text-foreground font-bold2"
                      style={{ fontSize: "14px", textTransform: "capitalize" }}
                    >
                      {formDataBank.typeBankAccount}
                    </p>
                    <div className="text-sm">
                      <button
                        type="button"
                        aria-label="Editar"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          editOptions(5);
                        }}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  /* =========================
     EFFECTS
  ========================== */
  useEffect(() => {
    setNewBankAccount(bankAccountOptions.filter((b) => b.value !== 9));

    let tokenIdWompi = localStorage.getItem("tokenIdWompi");
    if (tokenIdWompi !== null && tokenIdWompi !== undefined)
      setTokenIdWompi(tokenIdWompi);
  }, []);

  useEffect(() => {
    loadUser();
    loadUserBank();
    loadSteps();
  }, [loadUser, loadUserBank, loadSteps]);

  // ✅ DESPUÉS
  useEffect(() => {
    if (loadingBanks) return;

    const bank = bankUserStore?.bankAccount || creditUserStore?.bankAccount;

    let newValue = resolveInitialStep(
      pathname,
      bank,
      tokenIdWompi,
      tokenizedBanks,
    );

    if (bank) {
      if (bank === 30 || bank === 31) {
        setFormDataBank((prev) => ({
          ...prev,
          ...bankUserStore,
          bankAccount: bank,
          typeBankAccount: "ahorros",
        }));
      } else {
        setFormDataBank((prev) => ({
          ...prev,
          ...bankUserStore,
          bankAccount: bank,
        }));
      }
    }

    setCurrentStep(newValue);
    saveSteps({
      stepInternal: newValue,
      stepGeneral: parentStep,
      loading: true,
    });
  }, [
    bankUserStore,
    creditUserStore,
    pathname,
    loadingBanks,
    parentStep,
    tokenIdWompi,
    tokenizedBanks,
  ]);

  // useEffect(() => {
  //   const bank = bankUserStore?.bankAccount || creditUserStore?.bankAccount;

  //   if (!bank) return; // ninguna tiene valor, no hace nada

  //   setFormDataBank((prev) => ({
  //     ...prev,
  //     ...bankUserStore,
  //     bankAccount: bank || bankUserStore.bankAccount,
  //   }));

  //   let newValue = getInitialStep(bank, tokenIdWompi);
  //   setCurrentStep(newValue);
  //   saveSteps({
  //     stepInternal: newValue,
  //     stepGeneral: parentStep,
  //     loading: true,
  //   });
  // }, [bankUserStore, creditUserStore]);

  useEffect(() => {
    if (!stepCredit.stepInternal) return;
    setCurrentStep(stepCredit.stepInternal);
  }, []);

  return (
    <Fragment>
      {alertSession && (
        <>
          <WarningAlert
            isOpen={isOpenWarning}
            message={messsageAlert}
            isDesktop={isDesktop}
          />
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            isDesktop={isDesktop}
          />
          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          />
        </>
      )}
      <div className="w-full h-full">
        <StepContainer
          onNext={() => {
            handleNext(false);
          }}
          onPrev={handlePrev}
          canGoNext={currentStep === 1 || currentStep > 3 || currentStepResume}
          canGoPrev={currentStep === 1 || currentStep > 3 || currentStepResume}
          currentStepResume={currentStepResume}
          isDesktop={isDesktop}
          nextText={currentText}
          errors={isError}
          isLoading={isLoading}
          title={
            currentStep === 1 || currentStep > 3
              ? stepTitles[currentStep - 1]
              : ""
          }
          subtitle={
            currentStep === 1 || currentStep > 3
              ? stepSubTitles[currentStep - 1]
              : ""
          }
          isBancolombiaIcon={false}
        >
          <div
            className="transition-all duration-300 ease-in-out opacity-100 transform translate-x-0"
            style={{
              width: "-webkit-fill-available",
              overflowY: "auto",
              height: isDesktop ? "-webkit-fill-available" : getFormHeight(),

            }}
          >
            {!isDesktop && (
              <div className="mb-3 text-center flex flex-col items-center">
                <div className="text-sm mb-1.5" style={{ color: "#c8cbda" }}>
                  Paso {currentStepGeneral} de {stepTitlesGeneral.length}
                </div>
                <div
                  className="text-lg text-gray-800 max-w-50 sm:max-w-none"
                  style={{
                    fontSize: 17,
                    marginBottom: "16px",
                    marginTop: "8px",
                  }}
                >
                  {stepTitlesGeneral &&
                    stepTitlesGeneral[currentStepGeneral - 1]}
                </div>
              </div>
            )}
            {renderStep()}
          </div>

          {currentStep === 3 && !isDesktop && (
            <div
              style={{
                padding: "10px",
                backgroundColor: "#565584",
                color: "#E1DFE5",
                fontSize: "16px",
                borderRadius: "8px",
                marginBottom: "10px",
                marginTop: "10px",
              }}
            >
              Recuerda que la cuenta bancaria debe estar a tu nombre. Si
              proporcionas una de otra persona, tu solicitud podría anularse.
            </div>
          )}
        </StepContainer>
      </div>
    </Fragment>
  );
};

export default DatosFlowConnectBank;
